import { cn } from '#/lib/utils';

/**
 * icon 型刪除／移除（ghost）：平時紅字；hover 淡紅底＋紅字。
 * 覆蓋 vendor ghost 的 hover:bg-muted hover:text-foreground。
 */
export const DESTRUCTIVE_GHOST_BUTTON_CLASS = cn(
  'text-destructive',
  'hover:bg-destructive/10 hover:text-destructive',
  'focus-visible:border-destructive/40 focus-visible:ring-destructive/20',
  'dark:hover:bg-destructive/20 dark:hover:text-destructive',
);
